/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function show_add_to_cart(){
 var paymentContainer = document.querySelector('.product-form__payment-container');
  if (paymentContainer){
   paymentContainer.classList.add('visible');
  }
}
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    show_add_to_cart();  
  }, 500); // 0.5 seconds delay

var getQuoteLink = document.getElementById('get_quote');
if (getQuoteLink) {
    getQuoteLink.addEventListener('click', function (event) {
        event.preventDefault();

        var popups = document.querySelectorAll(".wsg-outer");

        popups.forEach(function (popup) {
            var h1Tag = popup.querySelector("h1");
 
            if (h1Tag && h1Tag.textContent.trim() === "Request a Quote") {
                var inputQuestion2 = popup.querySelector('input[name="question_2"]');
                if (inputQuestion2) {
                    var productTitle = document.querySelector(".product-meta__title.heading.h1");
                    var inputValue = productTitle ? "Quote Request: " + productTitle.textContent.trim() : "Quote Request";
                    inputQuestion2.value = inputValue;
                }

            } else {
                console.log("Popup does not contain the expected h1 tag");
            }
        });

    });
}

});





/* adjust the position of the next arrow for the homepage*/
    
    const divElem = document.querySelector('.home-slider .swiper-pagination');
    var lastSpan = '';
    var rect = '';
    var swiper  = '';  

if (divElem != null){
    // Get the last span element inside the div
    lastSpan = divElem.querySelector('span:last-child');
    rect = lastSpan.getBoundingClientRect();
    swiper = document.querySelector('.home-slider .swiper-button-next');
    swiper.style.left = rect.right + 'px';
    }
    


$(document).ready(function(){
    $(document).on('click', '.product-listing__menu li', function(){
      $('.product-listing__menu li').removeClass('active');
      $(this).addClass('active');
      var parent_div = $(this).parents(".product-listing");
      $(parent_div).find('.product-list__item').removeClass('active');
      const currentTab = $(this).attr('data-list');
     $(parent_div).find('.product-list__item').each( function(){
        if( currentTab == $(this).attr('data-collection') ){
          $(this).addClass('active');
        }
      });
    })

    position_slider_arrows();
  
});

function position_slider_arrows(){
    /*var products_home_list = document.querySelector('.swiper-pagination-products');
    var firstSpan_products = products_home_list.querySelector('span:first-child');    
    var lastSpan_products = products_home_list.querySelector('span:last-child');
    
    var swiper_prev = document.querySelector('.swiper-product-button-prev');
    var swiper_next = document.querySelector('.swiper-product-button-next');
    swiper_next.style.left = (lastSpan_products.offsetLeft + 10) + 'px';
    swiper_prev.style.left = (firstSpan_products.offsetLeft - 28) + 'px';*/
}

var selectorRef = document.querySelectorAll('.reflection-image');
	
if (selectorRef) {
  selectorRef.forEach(e => {
    let img = e.querySelector('img');
    let cloneImg = img.cloneNode(true);
    let imgDiv = document.createElement('div');

    imgDiv.appendChild(cloneImg);
    e.appendChild(imgDiv);
    
  });
}

jQuery(document).ready(function(){
  resize_product_info_desktop();
  jQuery(window).resize(function(){
    resize_product_info_desktop();
    position_slider_arrows();
  });



    var targetDiv = jQuery(".product-block-list__item--content .card .card__collapsible-button");

  // Create a MutationObserver instance
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === "aria-expanded" || mutation.attributeName === "class") {
        var newHeight = targetDiv.height();
        console.log("Div height changed:", newHeight);
        resize_product_info_desktop();
        // Call a function or execute any code you want after the div height changes
      }
    });
  });

  // Configure the MutationObserver to watch for changes in attributes
  var config = { attributes: true };

  // Start observing the target div
  if (targetDiv[0] != undefined){
  observer.observe(targetDiv[0], config);
  observer.observe(targetDiv[1], config);
  observer.observe(targetDiv[2], config);
  }
  // To stop observing, call the disconnect method on the observer:
  // observer.disconnect();
});


  


/*jQuery(".product-block-list__item--content .card").resize(function(){
  jQuery(this).toggleClass("")
})*/



function resize_product_info_desktop(){
  if (jQuery(window).width() >= 992){

    var Frequently_bought_together = 0;
    if (jQuery(".cbb-frequently-bought-container").length > 0){
      Frequently_bought_together = jQuery(".cbb-frequently-bought-container").height();
      console.log("Frequently_bought_together" + Frequently_bought_together);
    }

    var cards_height = 80;

    jQuery(".product-block-list__item--content .card").each(function(){
      
     cards_height += jQuery(this).height();
      
    
    });
    
    jQuery(".product-block-list__wrapper").css("height", jQuery(".product-block-list__item form").height() + jQuery(".card-description").height() +  cards_height);
    
    setTimeout(function(){
    var cards_height = 80;
    jQuery(".product-block-list__item--content .card").each(function(){
    cards_height += jQuery(this).height();
    });
        jQuery(".product-block-list__wrapper").css("height", jQuery(".product-block-list__item form").height() + jQuery(".card-description").height() +  cards_height);
    }, 500);
    
    const myTimeout = setTimeout(function(){
      var cards_height = 80;
     jQuery(".product-block-list__item--content .card").each(function(){
     cards_height += jQuery(this).height();
    });
      //console.log("last call: " + cards_height );
      jQuery(".product-block-list__wrapper").css("height", jQuery(".product-block-list__item form").height() + jQuery(".card-description").height()+  cards_height);
    }, 2000);
  }else{
    jQuery(".product-block-list__wrapper").css("height","auto");
  }
}

if ('objectFit' in document.documentElement.style === false) {
  Array.prototype.forEach.call(document.querySelectorAll('img[data-object-fit]'), image => {
    (image.runtimeStyle || image.style).background = `url("${image.src}") no-repeat 50%/${image.currentStyle ? image.currentStyle['object-fit'] : image.getAttribute('data-object-fit')}`;
    image.src = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${image.width}' height='${image.height}'%3E%3C/svg%3E`;
  });
}
if (document.querySelector('.product-more-details')) {
document.querySelector('.product-more-details').addEventListener('click', function(event) {
    event.preventDefault(); // Prevent the default anchor behavior

    const targetElement = document.querySelector('#full_description');

    var magic_number = 100;

    if (window.innerWidth > 600){
      magic_number = 168;
    }
    // Adjust scroll position
    window.scrollTo({
        top: targetElement.offsetTop - magic_number, // Adjust this value to match the height of your fixed header
        behavior: 'smooth' // Smooth scrolling
    });
});
}

if (document.querySelector('.template-collection .beae-paginate-link')) {
bind_pagination_buttons();
function bind_pagination_buttons(){
    const paginationButtons = document.querySelectorAll('.template-collection .beae-paginate-link');
    const targetElement = document.querySelector('#brand_collection');
    
    if (paginationButtons.length > 0 && targetElement) {
        paginationButtons.forEach(button => {
            button.addEventListener('click', function(event) {
                // event.preventDefault(); // Prevent the default anchor behavior if needed
    
                let magic_number = 100;
    
                if (window.innerWidth > 600) {
                    magic_number = 168;
                }
    
                // Adjust scroll position after a timeout
                setTimeout(function() {
                    window.scrollTo({
                        top: targetElement.offsetTop - magic_number, // Adjust the value to match the height of your fixed header
                        behavior: 'smooth' // Smooth scrolling
                    });
                  bind_pagination_buttons();
                }, 1000);
            });
        });

} else {
    console.log('Pagination button(s) or target element not found.');
}
}
}


 document.addEventListener('DOMContentLoaded', function() {
   
   var REDIRECT_PATH = '/pages/registration-success';

    var selector = '#create_customer, form[action$="/account"][method="post"]',
        $form = document.querySelectorAll(selector)[0];

    if ($form) {
      $redirect = document.createElement('input');
      $redirect.setAttribute('name', 'return_to');
      $redirect.setAttribute('type', 'hidden');
      $redirect.value = REDIRECT_PATH;
      $form.appendChild($redirect);
    }
   
  });